import React from 'react';
import '@atlaskit/css-reset';
import { JiraContextContainer } from '@atlassian/jira-context-container';
import { useIntl } from '@atlassian/jira-intl';
import { DependencySettingsPage } from '@atlassian/jira-portfolio-3-dependency-settings/src/ui/index.tsx';
import { SubProductUpdater } from '@atlassian/jira-spa-apps-common/src/analytics-sub-product/sub-product-updater/index.tsx';
import UFOSegment from '@atlassian/jira-ufo-segment';
import DocumentTitle from '../../../common/ui/document-title';
import messages from '../../../common/ui/messages';
import { SettingsContainer } from '../../../common/ui/settings';

const ArjSettingsDependencies = () => {
	const { formatMessage } = useIntl();
	const pageHeading = formatMessage(messages.settings);

	return (
		<UFOSegment name="plan-global-settings-dependencies-app">
			<JiraContextContainer>
				<SubProductUpdater subProduct="software" />
				<DocumentTitle pageHeading={pageHeading} />
				<SettingsContainer>
					<DependencySettingsPage />
				</SettingsContainer>
			</JiraContextContainer>
		</UFOSegment>
	);
};

export default ArjSettingsDependencies;
